import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { actions, getters } from "../../model";
import { getEventTimezone } from "redux/modules/event/selectors";
import Checkbox from "material-ui/Checkbox";

import { Div } from "components/Base";
import moment from "moment-timezone";
import { noop } from "lodash";

const decorate = R.compose(
  connect(
    state => ({
      timezone: getEventTimezone(state),
      data: getters.data(state)
    }),
    {
      selectItem: actions.selectItem
    }
  )
);

export const Subsession = ({
  session = {},
  timezone = "",
  selectItem = noop,
  isParentSession = false,
  data = {}
}) => {
  if (R.isEmpty(session) || R.isNil(session)) {
    return null;
  }
  const {
    isSelected = false,
    title = "",
    id = "",
    format = {},
    friendly_id = "",
    starts_at = null,
    ends_at = null
  } = session || {};
  const {
    starts_at: startAtParentSession = "",
    ends_at: EndsAtParentSession = ""
  } = data;
  return (
    <Div
      key={id}
      bra={1}
      ba={1}
      bc="gray3"
      p={5}
      mb={3}
      bg={{
        default: "white",
        hover: "gray1"
      }}
      width={1}
    >
      <Div mb={1} display="column.flex-start.flex-start">
        <Div mb={1} display="row.flex-start.flex-start">
          {!isParentSession && (
            <Div>
              <Checkbox
                checked={isSelected}
                onClick={() =>
                  selectItem({
                    id: id,
                    isSelected: !isSelected
                  })
                }
                disabled={false}
              />
            </Div>
          )}
          <Div mb={1} display="row.flex-start.center">
            <Div flex={1} mr={2} fw={4} fs={4} color="black">
              {title}
            </Div>
          </Div>
        </Div>
        <Div display="row.flex-start.center" width={1} ml={10}>
          <Div
            display="column"
            style={{
              width: "20%"
            }}
          >
            <Div fs={1}>Session ID</Div>
            <Div fs={1} color="gray7">
              {friendly_id}
            </Div>
          </Div>
          <Div
            display="column"
            style={{
              width: "30%"
            }}
          >
            <Div fs={1}>Starts At</Div>
            <Div fs={1} color="gray7">
              {moment
                .tz(starts_at ?? startAtParentSession, timezone)
                .format("MMM D, YYYY @ h:mm A")}
            </Div>
          </Div>
          <Div
            display="column"
            style={{
              width: "30%"
            }}
          >
            <Div fs={1}>Ends At</Div>
            <Div fs={1} color="gray7">
              {moment
                .tz(ends_at ?? EndsAtParentSession, timezone)
                .format("MMM D, YYYY @ h:mm A")}
            </Div>
          </Div>
          <Div
            display="column"
            style={{
              width: "30%"
            }}
          >
            <Div fs={1}>Format</Div>
            <Div fs={1} color="gray7">
              {R.propOr("-", "name")(format)}
            </Div>
          </Div>
        </Div>
      </Div>
    </Div>
  );
};

export default decorate(Subsession);
